import registry from '../../../registry';
import { SCREEN_RESIZE, BROWSER_TYPE, SCREEN_ORIENTATION } from './actions';

const uiState = {
  showMobileSidebar: false
};

export default function ui(state = uiState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SCREEN_RESIZE: {
      return {
        ...state,
        ...payload
      };
    }

    case SCREEN_ORIENTATION: {
      return {
        ...state,
        ...payload
      };
    }

    case BROWSER_TYPE: {
      return {
        ...state,
        browser: {
          ...payload,
          version: Number.parseFloat(payload?.version) || 0
        }
      };
    }

    default:
      return state;
  }
}

registry.register('ui', ui, uiState);
